export default "__VITE_ASSET__a0e2b85a__"